import React, { createContext, useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useUser, useUserActions } from "../pages/UserContext";

const AuthContext = createContext();

export const AuthProvider = ({ children, excludedRoutes }) => {
  const userDetails = useUser();
  const { isLoading } = useUserActions();
  const navigate = useNavigate();
  const location = useLocation();

  const isMember = !!userDetails?.is_member;
  const role = userDetails?.role ?? null;
  const accessRole = userDetails?.accessRole ?? null;
  const menus = userDetails?.menus || [];
  const isAuthenticated = !!userDetails && isMember;

  // Tri-state instead of a boolean: with the token gone from localStorage,
  // there's no synchronous way to know on first render whether a session
  // exists — 'loading' covers the gap while /users/details is in flight so
  // callers (App.js's guard()) don't flash an unauthenticated view first.
  const authStatus = isLoading ? "loading" : userDetails ? "authenticated" : "unauthenticated";

  useEffect(() => {
    if (isLoading) return;

    const isExcludedRoute = excludedRoutes.some((route) => {
      const pattern = new RegExp(`^${route.replace(/:[^/]+/g, "[^/]+")}$`);
      return pattern.test(location.pathname);
    });

    // KHUSUS Untuk Page Pendaftaran Rakernas
    if (location.pathname === "/pendaftaran-rakernas") {
      navigate("/pendaftaran-rakernas");
      return;
    }

    if (!userDetails) {
      if (!isExcludedRoute) {
        navigate("/");
      }
      return;
    }

    if (isMember && location.pathname === "/waiting") {
      if (role !== "admin") {
        navigate("/member-card");
      }
      return;
    }

    if (isMember) {
      if (isExcludedRoute && role !== "admin") {
        navigate("/member-card");
      }
      return;
    }

    // Session exists but isn't a member yet (pending admin approval).
    navigate("/waiting");
  }, [userDetails, isLoading, excludedRoutes, location.pathname, isMember, role, navigate]);

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        authStatus,
        isMember,
        role,
        accessRole,
        menus,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
